import React from "react";

import Box from "@busbud/design-system-components/dist/Box";
import BagSM from "@busbud/design-system-components/dist/Icons/Bag/SM";
import BusSM from "@busbud/design-system-components/dist/Icons/Bus/SM";
import CarSM from "@busbud/design-system-components/dist/Icons/Car/SM";
import EmailSM from "@busbud/design-system-components/dist/Icons/Email/SM";
import ExchangeSM from "@busbud/design-system-components/dist/Icons/Exchange/SM";
import FerrySM from "@busbud/design-system-components/dist/Icons/Ferry/SM";
import IDSM from "@busbud/design-system-components/dist/Icons/ID/SM";
import LuggageSM from "@busbud/design-system-components/dist/Icons/Luggage/SM";
import RefundSM from "@busbud/design-system-components/dist/Icons/Refund/SM";
import ShuttleSM from "@busbud/design-system-components/dist/Icons/Shuttle/SM";
import TicketsSM from "@busbud/design-system-components/dist/Icons/Tickets/SM";
import TrainSM from "@busbud/design-system-components/dist/Icons/Train/SM";
import WarningSM from "@busbud/design-system-components/dist/Icons/Warning/SM";
import Stack from "@busbud/design-system-components/dist/Stack";

import type { SimplifiedTerms } from "@app/modules/terms/flatten-terms";

import { Markdown } from "../../text-formatting/markdown";

interface Props {
  terms: SimplifiedTerms;
}

const icon_props = { flexShrink: 0, color: "text.tertiary.opaque" } as const;

const IconComponentMapping = {
  // ban: "",
  "envelope-open": <EmailSM {...icon_props} />,
  "id-card": <IDSM {...icon_props} />,
  "shopping-bag": <BagSM {...icon_props} />,
  suitcase: <LuggageSM {...icon_props} />,
  bus: <BusSM {...icon_props} />,
  train: <TrainSM {...icon_props} />,
  carpool: <CarSM {...icon_props} />,
  ferry: <FerrySM {...icon_props} />,
  shuttle: <ShuttleSM {...icon_props} />,
  "dollar-sign": <RefundSM {...icon_props} />,
  "exchange-alt": <ExchangeSM {...icon_props} />,
  ticket: <TicketsSM {...icon_props} />,
  warning: <WarningSM {...icon_props} />,
  none: <Box {...icon_props} width="16px" />
};

const FallbackIcon = <WarningSM {...icon_props} />;

const SimplifiedTermsEntry: React.FC<Props> = props => {
  const { terms } = props;
  const { icon, content } = terms;

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      data-testid="simplified-terms-entry"
    >
      {(icon &&
        IconComponentMapping[icon as keyof typeof IconComponentMapping]) ||
        FallbackIcon}
      <Markdown body_font_size="sm" content={content} link_target_blank />
    </Stack>
  );
};

export { SimplifiedTermsEntry };
